module.exports = __webpack_public_path__ + "img/20200621_095723.596a1222.jpg";